import { faSend } from '@fortawesome/pro-regular-svg-icons';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CreatedByLabel } from 'assets/js/pages/contacts/single/timeline/timeline-list/item/components/CreatedByLabel';
import * as ActivityItem from 'assets/js/pages/contacts/single/timeline/timeline-list/item/items/ActivityItem';
import { Attachments } from 'assets/js/pages/contacts/single/timeline/timeline-list/item/items/engage-email/Attachments';
import { Contact, ExternalEmailActivity } from 'types/domain';

interface ExternalEmailProps {
    item: ExternalEmailActivity;
    contact: Contact;
}

const ExternalEmail = ({ item, contact }: ExternalEmailProps) => {
    const { resource: email } = item;
    const { name_display = '' } = contact;

    return (
        <ActivityItem.Root>
            <ActivityItem.Trigger>
                <ActivityItem.Icon className="bg-blue-50">
                    <FontAwesomeIcon className="text-blue-500" icon={faSend} />
                </ActivityItem.Icon>
                <div className={'flex items-center gap-x-4'}>
                    <p>
                        <CreatedByLabel createdBy={item.created_by} /> sent{' '}
                        <span className="font-medium">{name_display}</span> an email
                    </p>
                    <p className="flex shrink-0 items-center gap-x-3 font-medium">
                        <span className="[&>*]:inline">
                            <FontAwesomeIcon icon={faEnvelope} />
                        </span>
                        <span>Sent outside Givebutter</span>
                    </p>
                </div>
            </ActivityItem.Trigger>
            <ActivityItem.Content className="flex w-full flex-grow flex-col gap-6 p-8">
                {email.subject && <div>{email.subject}</div>}
                <div dangerouslySetInnerHTML={{ __html: email.body ?? '' }} />
                <Attachments list={email.attachments} />
            </ActivityItem.Content>
        </ActivityItem.Root>
    );
};

export { ExternalEmail };
